<ng-container *ngIf="!(updatingEstados$ | async); else loadingBlock">
    <ng-container *ngIf="(estados$ | async) as estados">
        <div fxLayout="column" fxLayoutGap="12px">
            <div fxLayout="row" fxLayoutAlign="center start">
                <div fxLayout="column" fxFlex.gt-md="25" fxFlex="80" fxLayoutGap="12px">
                    <button *ngFor="let estado of estados" (click)="onClick(estado.id)" mat-flat-button color="accent"
                        class="full-width">
                        {{estado.nombre}}
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-template #loadingBlock>
    <div fxLayout="column" fxLayoutAlign="center center">
        <mat-progress-spinner color="primary" diameter="50" mode="indeterminate">
        </mat-progress-spinner>
    </div>
</ng-template>